import React, { useState } from 'react';
import { Input, Button } from 'antd';
import { useQuickAddToThrottleExemptions } from 'mutation/mail';
import { isValidEmail } from 'services/common';

const QuickAddExemption = () => {
  const [email, setEmail] = useState('');
  const {
    mutateAsync: addToExemptions,
    isLoading,
  } = useQuickAddToThrottleExemptions({ onSuccess: () => setEmail('') });

  const handleEmailChange = e => setEmail(e.target.value);

  const onSubmit = () => {
    if (isValidEmail(email)) {
      addToExemptions([{ email }]);
    }
  };

  return (
    <Input
      addonAfter={
        <Button
          disabled={!isValidEmail(email)}
          size="small"
          type="link"
          onClick={onSubmit}
        >
          Quick Add
        </Button>
      }
      disabled={isLoading}
      placeholder="Add to exemptions list"
      size="small"
      style={{ minWidth: 350 }}
      value={email}
      onChange={handleEmailChange}
    />
  );
};

export default QuickAddExemption;
